import { render } from "./Novedad.vue?vue&type=template&id=169e4669&scoped=true"
import script from "./Novedad.vue?vue&type=script&lang=js"
export * from "./Novedad.vue?vue&type=script&lang=js"

import "./Novedad.vue?vue&type=style&index=0&id=169e4669&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169e4669"]])

export default __exports__